/**
 * @generated SignedSource<<581477ebcb6c17dfb2b8f269eae473e7>>
 * @relayHash 4932669deeda53c980e65a5eb3303f78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af40b3fdd40649eb672a24412bbe40daa06040bcc8260b9b01a08b5a3956634c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardViewInput = {
  jiraBoardViewQueryInput: JiraBoardViewQueryInput;
  settings?: JiraBoardViewSettings | null | undefined;
};
export type JiraBoardViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraBoardViewProjectKeyAndItemIdQuery | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraBoardViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraBoardViewSettings = {
  filterJql?: string | null | undefined;
  groupBy?: string | null | undefined;
};
export type ViewSettingsPanelContentQuery$variables = {
  viewInput: JiraBoardViewInput;
};
export type ViewSettingsPanelContentQuery$data = {
  readonly jira_boardView: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CardOptionSettings" | "RemoveResolvedItems">;
  };
};
export type ViewSettingsPanelContentQuery = {
  response: ViewSettingsPanelContentQuery$data;
  variables: ViewSettingsPanelContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "viewInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "viewInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ViewSettingsPanelContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "JiraBoardView",
          "kind": "LinkedField",
          "name": "jira_boardView",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*: any*/),
              "action": "THROW",
              "path": "jira_boardView.id"
            },
            {
              "kind": "FragmentSpread",
              "name": "RemoveResolvedItems"
            },
            {
              "kind": "FragmentSpread",
              "name": "CardOptionSettings"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_boardView"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewSettingsPanelContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraBoardView",
        "kind": "LinkedField",
        "name": "jira_boardView",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "completedIssueSearchCutOffInDays"
          },
          {
            "alias": "menuCardOptions",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 200
              }
            ],
            "concreteType": "JiraBoardViewCardOptionConnection",
            "kind": "LinkedField",
            "name": "cardOptions",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraBoardViewCardOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "fieldId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "typeKey"
                              },
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canToggle"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "enabled"
                          }
                        ],
                        "type": "JiraBoardViewFieldCardOption"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": "cardOptions(first:200)"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "af40b3fdd40649eb672a24412bbe40daa06040bcc8260b9b01a08b5a3956634c",
    "metadata": {},
    "name": "ViewSettingsPanelContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4416a0c58a0315586baea0bc4cb3d3fc";

export default node;
